var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgParking = function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 28.854,
    viewBox: "0 0 30.5 28.854"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0.5 -0.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x2: 13.088,
    transform: "translate(5.99 27.768)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 2.066,
    transform: "translate(27.934 15.042)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x1: 2.066,
    transform: "translate(27.934 18.042)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    y1: 28.355,
    transform: "translate(24.901 0.753)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y1: 28.355,
    transform: "translate(0 0.753)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 25,
    transform: "translate(0 0.753)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  })))));
};

export { SvgParking as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMC41IiBoZWlnaHQ9IjI4Ljg1NCIgdmlld0JveD0iMCAwIDMwLjUgMjguODU0Ij4KICA8ZyBpZD0iR3JvdXBfNTUiIGRhdGEtbmFtZT0iR3JvdXAgNTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSAtMC4yNTMpIj4KICAgIDxnIGlkPSJHcm91cF81MSIgZGF0YS1uYW1lPSJHcm91cCA1MSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzg1IiBkYXRhLW5hbWU9IkxpbmUgODUiIHgyPSIxMy4wODgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuOTkgMjcuNzY4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyMjM4IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODYiIGRhdGEtbmFtZT0iTGluZSA4NiIgeDE9IjIuMDY2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy45MzQgMTUuMDQyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyMjM4IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfOTAiIGRhdGEtbmFtZT0iTGluZSA5MCIgeDE9IjIuMDY2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy45MzQgMTguMDQyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyMjM4IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODciIGRhdGEtbmFtZT0iTGluZSA4NyIgeTE9IjI4LjM1NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuOTAxIDAuNzUzKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAyMjM4IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfODgiIGRhdGEtbmFtZT0iTGluZSA4OCIgeTE9IjI4LjM1NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjc1MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMjIzOCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzg5IiBkYXRhLW5hbWU9IkxpbmUgODkiIHgxPSIyNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjc1MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMjIzOCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";